class MobileDock extends HTMLElement {
    constructor() {
        super(), new theme.initWhenVisible(this.init.bind(this))
    }
    get section() {
        return this.closest(".mobile-dock-section")
    }
    init() {
        const t = document.querySelector(".header-section");
        null === t ? this.section.classList.add("active") : t.classList.contains("header-sticky") || (this.scrollY = parseInt(t.getBoundingClientRect().bottom), window.addEventListener("scroll", theme.utils.throttle(this.onScroll.bind(this)), !1)), setTimeout((() => {
            document.documentElement.style.setProperty("--mobile-dock-height", `${this.offsetHeight}px`)
        }))
    }
    onScroll() {
        window.scrollY >= this.scrollY ? this.section.classList.add("active") : this.section.classList.remove("active")
    }
}
customElements.define("mobile-dock", MobileDock);